import { render, staticRenderFns } from "./CompraEdicaoComissao.vue?vue&type=template&id=6dd009ec"
import script from "./CompraEdicaoComissao.vue?vue&type=script&lang=js"
export * from "./CompraEdicaoComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports